// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import documentSignerEntity from './entities/document-signer.json';
import documentSignerMenu from '../pages/document-signer/menu.json';
import documentSignerFullForm from '../pages/document-signer/forms/full.json';
import documentSignerContextForm from '../pages/document-signer/forms/context.json';
import documentSignerMiniForm from '../pages/document-signer/forms/mini.json';
import documentSignerLookupForm from '../pages/document-signer/forms/lookup.json';
import documentSignerTableView from '../pages/document-signer/views/table.json';
import documentSignerCardsView from '../pages/document-signer/views/cards.json';
import documentSignerCalendarView from '../pages/document-signer/views/calendar.json';
import documentSignerDashboardView from '../pages/document-signer/views/dashboard.json';

/** Тип запису «Підписант» зі сторінками пакета: меню, форми та подання з pages/document-signer/. */
export const documentSignerDefinition: IRecordTypeDefinition = {
  ...documentSignerEntity,
  views: assembleViewSet({
      table: documentSignerTableView,
      cards: documentSignerCardsView,
      calendar: documentSignerCalendarView,
      dashboard: documentSignerDashboardView,
  }),
  form: documentSignerFullForm,
  forms: { full: documentSignerFullForm, context: documentSignerContextForm, mini: documentSignerMiniForm, lookup: documentSignerLookupForm },
  menu: documentSignerMenu,
} as IRecordTypeDefinition;
